import tempMeeApi from '../../../apis/tempMee';

export const revokeACHAuthorization = async (bankId) => {
  const response = await tempMeeApi.post(
    `/payment/admin/account/payment-method/${bankId}/revoke`,
    {},
  );

  return response.data;
};
